import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useConfig } from '../contexts/ConfigContext'

const Footer = () => {
  const { config } = useConfig()
  const currentYear = new Date().getFullYear()
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <footer className="bg-gray-tech text-white">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-white rounded-lg flex items-center justify-center overflow-hidden">
              {(isMobile
                ? (config?.identity?.footer_logo_mobile || config?.identity?.logo_mobile)
                : (config?.identity?.footer_logo_pc || config?.identity?.logo_pc)
              ) ? (
                <img 
                  src={isMobile
                    ? (config?.identity?.footer_logo_mobile || config?.identity?.logo_mobile)
                    : (config?.identity?.footer_logo_pc || config?.identity?.logo_pc)
                  } 
                  alt={config?.identity?.site_name || '摩恒科技'} 
                  className="object-contain p-1"
                  style={{ 
                    maxWidth: `${config?.identity?.logo_width || 430}px`, 
                    maxHeight: `${config?.identity?.logo_height || 200}px` 
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/api/placeholder/40/40';
                  }}
                />
              ) : (
                <div className="w-10 h-10 bg-primary flex items-center justify-center">
                  <span className="text-white font-bold text-lg">M</span>
                </div>
              )}
              </div>
              <div>
                <h3 className="text-xl font-bold">{config?.identity?.site_name || '无锡市摩恒科技有限公司'}</h3>
                <p className="text-gray-300 text-sm">
                  {config?.identity?.site_name?.includes('无锡市摩恒科技有限公司') 
                    ? 'Wuxi Moheng Technology Co., Ltd.' 
                    : config?.identity?.site_name || 'Wuxi Moheng Technology Co., Ltd'}
                </p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              专业科学的技术解决方案提供商，致力于为客户提供更多的创新技术产品和服务。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white transition-colors">
                  产品介绍
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-gray-300 hover:text-white transition-colors">
                  公司简介
                </Link>
              </li>
              <li>
                <Link to="/downloads" className="text-gray-300 hover:text-white transition-colors">
                  技术支持
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">联系我们</h4>
            <div className="space-y-2 text-gray-300">
              <p>地址：{config?.site?.company_address || '江苏省无锡市宜兴市阳泉西路858号4F'}</p>
              <p>电话：{config?.site?.contact_phone || '0510-87902353'}</p>
              <p>邮箱：{config?.site?.contact_email || 'info@wxmhkj.cn'}</p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-600 mt-8 pt-8 text-center">
          <div className="text-gray-300 text-sm">
            <p>{config?.copyright?.copyright_text || `© ${currentYear} 无锡市摩恒科技有限公司 版权所有`}</p>
          </div>
        </div>

        {/* ICP备案信息 */}
        {config?.copyright?.show_icp || config?.copyright?.show_police ? (
          <div className="text-center mt-4 pt-4 border-t border-gray-600">
            <div className="text-gray-400 text-xs">
              {config?.copyright?.show_icp && config?.copyright?.icp_number && (
                <>
                  <a 
                    href={config?.copyright?.icp_link || 'https://beian.miit.gov.cn'} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="hover:text-white transition-colors"
                  >
                    {config?.copyright?.icp_number}
                  </a>
                  {config?.copyright?.show_police && config?.copyright?.police_record_number && (
                    <span className="mx-2">|</span>
                  )}
                </>
              )}
              {config?.copyright?.show_police && config?.copyright?.police_record_number && (
                <a 
                  href={config?.copyright?.police_record_link || 'http://www.beian.gov.cn'} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  {config?.copyright?.police_record_number}
                </a>
              )}
            </div>
          </div>
        ) : null}
      </div>
    </footer>
  )
}

export default Footer
